import { Box, Flex, Input, Avatar } from '@chakra-ui/react'
import React, { useContext, useEffect, useRef, useState } from 'react'
import Navbar from '../Navbar/Navbar'
import Feed from '../Tweet/Feed'
import TweetForm from '../Tweet/TweetForm'
import HomeFeed  from '../HomeFeed'

import { TokenContext } from '../App'
import { baseUrl } from '../settings'
import { Link } from 'react-router-dom'

import '../PageCSS/Home.css'

const Home = () => {

    // @ts-ignore
    const {token, setToken} = useContext(TokenContext);
    const searchBoxRef = useRef(null)
    const [query, setQuery] = useState("")
    const [timer, setTimer] = useState(null)
    const [result, setResult] = useState(null)

    useEffect(() => {
        function getData() {
            fetch(`${baseUrl}/tweet/search/${query}`)
            .then(res => res.json())
            .then(data => setResult(data))
        }

        function debounce() {
            if(timer === null) {
                let id = setTimeout(() => {
                    getData()
                }, 1000);
                setTimer(id);
            }
            else {
                clearInterval(timer);
                let id = setTimeout(() => {
                    getData()
                }, 1000);
                setTimer(id);
            }
        }
        debounce()
    }, [query])

    const handleQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.value === "") {
            setResult(null)
        }
        setQuery(e.target.value);
    }

    function showResultJSX() {
        // @ts-ignore
        let renderData = result.map((elem) => {
            return (
                <Box key={elem.id}>
                    <Link to={`/profile/${elem.tweeter.username}`}><Avatar src={elem.tweeter.image_url}></Avatar></Link>
                    <Link to={`/profile/${elem.tweeter.username}`}><Box>{elem.tweeter.username}</Box></Link>
                    <Link to={`/tweet/${elem.id}`}><Box>{elem.content}</Box></Link>
                </Box>
            )
        })

        return (
            <Box>
                {renderData}
            </Box>
        )
    }

    return (
        <Flex justify={"normal"} paddingX="1rem">
            <Box flexGrow={1} paddingX="1rem">
                <Navbar></Navbar>
            </Box>
            <Box flexGrow={2} paddingX="1rem">
                <Flex direction="column">
                <TweetForm></TweetForm>
                {token === "" || token === null? <Feed url={`${baseUrl}/tweet`}></Feed>: <HomeFeed url={`${baseUrl}/tweet`}></HomeFeed>}
            </Flex>
            </Box>
            <Box className='search-box' flexGrow={1} paddingX="1rem" borderLeft={"1px solid gray"} borderColor={"gray.200"}>
                <Input type="text" placeholder='Search Tweets' onChange={handleQueryChange} ref={searchBoxRef}></Input>
                {result === null ? "": showResultJSX()}
            </Box>
        </Flex>
    )
}

export default Home
